import { ThemeProps } from 'styled-components';
import { Colors } from '../helpers/colors';
import { Theme } from '../theme';

export const twoLayeredBoxShadow = (
  innerColor: Colors[keyof Colors] | string,
  outerColor: Colors[keyof Colors] | string
) => ({ theme }: ThemeProps<Theme>): string => {
  const innerColorString =
    typeof innerColor === 'string' ? innerColor : innerColor({ theme });
  const outerColorString =
    typeof outerColor === 'string' ? outerColor : outerColor({ theme });
  return `0px 0px 0 2px ${innerColorString}, 0px 0px 0 4px ${outerColorString}`;
};

export const logoSmallWidth = '134px';
export const logoLargeWidth = '205px';
